import Enum from "./Enum";

export class PresentationStatus extends Enum {};

const PresentationStatuses = {
  PREPARATION: new PresentationStatus('PREPARATION','자료 확인'),
  PRESENTATION: new PresentationStatus('PRESENTATION','녹화'),
}

export default PresentationStatuses;